import { HttpClient } from '@/shared/lib/http-client';

export const generateTelegramLinkToken = async () => {
  const response = await HttpClient.post('/auth/telegram/link-token');
  return response.data?.data;
};

export const loginWithTelegram = async (telegramAuthData) => {
  const response = await HttpClient.post('/auth/telegram/login', { ...telegramAuthData, is_web: true });
  return response.data?.data;
};
